<template>
  <div class="toolbar">
    <div
        v-for="tab in tabs"
        :key="tab.key"
        :class="['tab', { active: activeTab === tab.key }]"
        @click="$emit('change', tab.key)"
    >
      <v-icon x-small class="mr-1" :color="activeTab === tab.key ? 'var(--color-primary)' : 'var(--text-platform)'">{{tab.icon}}</v-icon>
      {{ tab.label }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeTab: String
  },
  data() {
    return {
      tabs: [
        { key: 'live', label: 'Match', icon: 'mdi-soccer-field' },
        { key: 'stats', label: 'Stats', icon: 'mdi-chart-bar' },
        { key: 'timeline', label: 'Timeline', icon: 'mdi-format-list-bulleted' },
        { key: 'lineups', label: 'Lineups', icon: 'mdi-account-multiple' }
      ]
    }
  }
}
</script>

<style scoped>
.toolbar {
  display: flex;
  background: #111 ;
  border-bottom: 1px solid #1a1a1a;
}

.tab {
  flex: 1;
  text-align: center;
  padding: 8px 0;
  font-size: var(--font-size-3xl);
  color: var(--text-platform);
  position: relative;
  cursor: pointer;
}

.tab.active {
  color: var(--color-primary);
}

.tab.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 20%;
  width: 60%;
  height: 3px;
  background: var(--color-primary);
  border-radius: 3px;
}
</style>